import React, { useState, useEffect, useRef, useContext } from 'react';
import {useHistory} from 'react-router-dom';
import { Row, Col, Button, Spinner, Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation, Trans } from 'react-i18next';
import { Card } from '../../components';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { HashLink as Link } from 'react-router-hash-link';
import {getCardsForWalletAddress} from './service'
import styles from './MyCards.module.scss';
import { useCookies } from 'react-cookie';
import { Web3Context } from '../../web3/Web3Context';
import { customConfirm, ConnectModal } from '../../components/Connect';

const MyCards = (props) => {
    const { t, i18n } = useTranslation();
    const [walletAddress, setWalletAddress] = useState(null);
    const [cards, setCards] = useState();
    const [cookies, setCookie] = useCookies(['lastConnectorUsed']);
    const {connect} = useContext(Web3Context);
    const target = useRef(null);
    const history  = useHistory();
    

    useEffect( () => {
        (async ()=> {
                let wallet = cookies.lastConnectorUsed || await customConfirm(ConnectModal);
                try{
                    let {selectedAccount, web3} = await connect({connector: wallet})
                    setWalletAddress(selectedAccount)
                }catch(e){
                    console.error("Failed to connect to wallet")
                    history.push('/')
                }
        })()
    },[])

    useEffect( () => {
        (async ()=> {
            if(walletAddress){
                const result = await getCardsForWalletAddress(walletAddress);
                setCards(result);
            }
        })()
    },[walletAddress])

    const renderCards = () => {
        return cards && cards.length > 0?
            <div className = {styles.cards_grid}>{
            cards.map(card=>{
                return <Card key={card} data={{tokenId:card}}/>
            })} </div> : <div className={styles.buy_now_button}><Link to="/#buy-now" className="btn btn-cdh-primary">{t("Buy Now")}</Link></div>
        
    }

    return (
        <div className={styles.cards_container}>
            <Container className={styles.my_cards}>
            <Row>
                <Col md={2}>
                    <Row  className = {styles.wallet_address_pane}>
                    <div className={styles.header}><span className={styles.user_icon}><FontAwesomeIcon icon={faUser} /></span>{t("Wallet Address")}</div>
                    <div className={styles.address}>{walletAddress}</div>
                    <div className={styles.cards_count}>{t("Cards")} : {cards?cards.length:<Spinner animation="border" variant="secondary" size="sm"/>}</div>
                    </Row>
                </Col> 
                <Col md={10}>{renderCards()}</Col>
            </Row>
            </Container>

            
            
        </div>
    );
};

export { MyCards };


/*
<Button ref={target} variant="cdh-primary" onClick={handleCopyAddress}>{walletAddress.slice(0, 10)}</Button>
                <Overlay target={target.current} show={showTT} placement="top" rootClose={true} onHide={() => setShowTT(false)}>
                    <Tooltip>Copied!</Tooltip>
                </Overlay>
*/